export default "__VITE_ASSET__BZW9sV7x__"